<script type="ts">
  import FeedbackForm from "../components/FeedbackForm.svelte";
  import PlayerChipList from "../components/player_chips/PlayerChipList.svelte";
  import StartGameButton from "../components/StartGameButton.svelte";
  import { gameState } from "../store";
  import { getRandomEmoji } from "../utils/randomEmojy";

  const onChangeUserIcon = (playerId: number) => {
    const newPlayers = $gameState.draft.players.map((p) => {
      if (p.id === playerId) {
        return {
          ...p,
          color: "#" + (((1 << 24) * Math.random()) | 0).toString(16).padStart(6, "0"),
          icon: getRandomEmoji(),
        };
      }
      return p;
    });
    gameState.update((state) => {
      return {
        ...state,
        draft: {
          ...state.draft,
          players: newPlayers,
        },
      };
    });
  };

  const onDeleteUser = (playerId: number) => {
    const newPlayers = $gameState.draft.players.filter(
      (p) => p.id !== playerId
    );
    gameState.update((state) => {
      return {
        ...state,
        draft: {
          ...state.draft,
          players: newPlayers,
        },
      };
    });
  };
</script>

<h1 class="mt-6 mb-4 text-4xl font-extrabold text-center">Wer spielt mit?</h1>

{#if $gameState.draft != undefined}
  <PlayerChipList
    players={$gameState.draft.players}
    {onChangeUserIcon}
    {onDeleteUser}
  />
{/if}
<FeedbackForm />
<StartGameButton />
